export enum LevelOfContainmentCode {
    THIRTY = '30',
    FIFTY = '50',
    SIXTY = '60',
    CONTAINS = 'CONTAINS',
    FREE_FROM = 'FREE_FROM',
    MAY_CONTAIN = 'MAY_CONTAIN',
    UNDECLARED = 'UNDECLARED',
}
